import getVariantsProductVariantUtil from 'modules/product-variant/utils/get-variants'

/**
 * @param  {ProductVariantCollection} productVariant
 * @returns {ProductVariantCollection[]}
 */
export default function getAllVariantsProductVariantUtil (productVariant) {
  return [
    productVariant,
    ...getVariantsProductVariantUtil(productVariant)
  ]
}
